export default __webpack_public_path__ + "static/lava-llama-screenshot-narrow-fb786ef9b4f48e44f36520d13184ff3d.png";